import Extension from 'owa-service/lib/contract/Extension';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getPreviousAdminInstalledAddins,
    setPreviousAdminInstalledAddins,
    isPreviousAdminAddinsInCache,
} from '../utils/adminAddinsCache';

// This function finds out new admin installed addins and returns array of
// addinId for same.
//
// @param addins List of addins (Extension) received in GetExtensibilityContext
//               response.
export function getNewAdminInstalledAddins(addins: Extension[]): string[] {
    let currentAdminAddins = getAdminInstalledAddins(addins);

    if (!isPreviousAdminAddinsInCache()) {
        // If we don't have anything in cache yet, this is our first call to
        // GetExtensibilityContext for this experiment. Let's save current
        // admin addins and return.
        setPreviousAdminInstalledAddins(currentAdminAddins);
        if (isFeatureEnabled('addin-exp-testPinOldAdminAddins')) {
            return currentAdminAddins;
        } else {
            return [];
        }
    }

    let previousAdminAddins = getPreviousAdminInstalledAddins();

    // Find our newly installed addins.
    let newAddins = currentAdminAddins.filter(key => previousAdminAddins.indexOf(key) < 0);
    setPreviousAdminInstalledAddins(currentAdminAddins);
    return newAddins;
}

// This helper function finds out admin installed addins from given 'addins' list
// and returns array of addinId for the same.
//
// @param addins List of addins (Extension) received in GetExtensibilityContext response.
// @returns Array of addinId (string) of 'admin installed' addins.
function getAdminInstalledAddins(addins: Extension[]): string[] {
    let addinKeys: string[] = [];

    for (const addin of addins) {
        if (!addin.Enabled) {
            continue;
        }

        if (!addin.ExtensionPointCollection) {
            continue;
        }

        // Admin installed addin.
        if (addin.OriginString === 'Organization') {
            let key = addin.Id.toLowerCase();
            addinKeys.push(key);
        }
    }
    return addinKeys;
}
